import { fetch } from '@atlassian/eoc-fetch';
export const getPermissionsEndpoint = () => fetch(`/v1/users/permissions`);
export const createCustomRoleEndpoint = newCustomRole => fetch(`/v1/users/roles`, {
  method: 'POST',
  body: newCustomRole
});
export const editCustomRoleEndpoint = updatedCustomRole => {
  const {
    id
  } = updatedCustomRole;
  return fetch(`/v1/users/roles/${id}`, {
    method: 'PATCH',
    body: updatedCustomRole
  });
};
export const deleteCustomRoleEndpoint = id => {
  return fetch(`/v1/users/roles/${id}`, {
    method: 'DELETE'
  });
};
export const getCustomRolesListEndpoint = () => fetch(`/v1/users/roles`);